'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _clickOutside = require('click-outside');

var _clickOutside2 = _interopRequireDefault(_clickOutside);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _dekuSlideout = require('@viskan/deku-slideout');

var _dekuSlideout2 = _interopRequireDefault(_dekuSlideout);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

var _togglerPresentation = require('../../utils/toggler-presentation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unbind = {};
var close = function close(props) {
	return function () {
		return props.toggle({ open: false });
	};
};

var afterRender = function afterRender(_ref, el) {
	var props = _ref.props;

	if (!props.closeOnClickOutside) {
		return;
	}

	if (unbind[props.id]) {
		unbind[props.id]();
	}

	unbind[props.id] = (0, _clickOutside2.default)(el, function () {
		return props.toggle({ open: false });
	});
};

var getIcon = function getIcon(props) {
	var iconInsideClose = props.iconInsideClose,
	    styleClasses = props.styleClasses;

	var icon = iconInsideClose;

	if (!icon) {
		return (0, _magicVirtualElement2.default)('noscript', null);
	}

	try {
		var parsedIcon = JSON.parse(icon);

		return (0, _magicVirtualElement2.default)(
			'span',
			{ 'class': ['CMS-Slideout-close-inside', styleClasses.Slideout_Close_Icon], 'data-style-attr': 'Slideout_Close_Icon', onClick: close(props) },
			(0, _magicVirtualElement2.default)('i', { 'class': parsedIcon.prefix + ' fa-' + parsedIcon.x.name })
		);
	} catch (err) {
		return (0, _magicVirtualElement2.default)('noscript', null);
	}
};

var useWithStickyHeader = function useWithStickyHeader(_ref2) {
	var underSticky = _ref2.underSticky;

	if (!underSticky) {
		return {};
	}

	return { height: window.innerHeight + 'px' };
};

var useFullWidth = function useFullWidth(_ref3) {
	var fullWidth = _ref3.fullWidth;

	if (!fullWidth) {
		return {};
	}

	return { width: '100vw' };
};

var beforeMount = function beforeMount(_ref4) {
	var props = _ref4.props;

	props.setStateConfiguration({
		actionDuration: props.actionDuration,
		closeOnUrlChange: props.closeOnUrlChange,
		onAction: props.onAction,
		onActionAction: props.onActionAction,
		keepOpen: props.keepOpen,
		identifier: props.identifier
	});

	if (props.openByDefault) {
		props.toggle({ open: true });
	}
};

var afterUpdate = function afterUpdate(_ref5, prevProps) {
	var props = _ref5.props;
	var configuration = props.configuration;

	var duration = parseInt(configuration.actionDuration, 10);
	var openValue = { OPEN: true, CLOSE: false };

	if (configuration && prevProps.configuration && configuration.force !== prevProps.configuration.force && configuration.force) {
		props.toggle({ open: openValue[configuration.force], removeForce: true });

		if (duration) {
			setTimeout(function () {
				return props.toggle({ open: !openValue[configuration.force] });
			}, duration);
		}
	}

	if (!(0, _deepEqual2.default)({
		actionDuration: props.actionDuration,
		closeOnUrlChange: props.closeOnUrlChange,
		onAction: props.onAction,
		onActionAction: props.onActionAction,
		keepOpen: props.keepOpen,
		identifier: props.identifier
	}, {
		actionDuration: configuration.actionDuration,
		closeOnUrlChange: configuration.closeOnUrlChange,
		onAction: configuration.onAction,
		onActionAction: configuration.onActionAction,
		keepOpen: configuration.keepOpen,
		identifier: configuration.identifier
	})) {
		props.setStateConfiguration({
			actionDuration: props.actionDuration,
			closeOnUrlChange: props.closeOnUrlChange,
			onAction: props.onAction,
			onActionAction: props.onActionAction,
			keepOpen: props.keepOpen,
			identifier: props.identifier
		});
	}
};

var render = function render(_ref6) {
	var props = _ref6.props;
	var id = props.id,
	    open = props.open,
	    side = props.side,
	    styleClasses = props.styleClasses,
	    toggle = props.toggle,
	    underSticky = props.underSticky;

	var children = props.children.length > 0 ? props.children : (0, _magicVirtualElement2.default)('div', { 'data-id': id, 'class': 'CMS-Slideout-placeholder CMS-Component' });
	var presentationOpen = (0, _togglerPresentation.getPresentation)('Open', props);
	var presentationClosed = (0, _togglerPresentation.getPresentation)('Closed', props);
	var slideoutStyles = _extends({}, useWithStickyHeader(props), useFullWidth(props));

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Slideout', { 'CMS-Slideout--open': open }, styleClasses.Wrapper], 'data-style-attr': 'Wrapper' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-Slideout-toggle', styleClasses.Toggle], 'data-style-attr': 'Toggle', onClick: toggle },
			open ? presentationOpen : presentationClosed
		),
		(0, _magicVirtualElement2.default)(
			_dekuSlideout2.default,
			{ 'class': [{ 'Slideout-stickyHeader': underSticky }], styleClasses: styleClasses, styles: slideoutStyles, align: side.toLowerCase(), open: open },
			props.iconInsideClose && getIcon(props),
			children
		)
	), props);
};

exports.default = { afterRender: afterRender, afterUpdate: afterUpdate, beforeMount: beforeMount, render: render };